<div class="bar-chart-container">
  <app-structure-graph-bar-simple [graphOptions]="graphOptions"></app-structure-graph-bar-simple>
</div>
